import React from 'react';
import styled from 'styled-components';
import {ApolloError} from "@apollo/client";

const Error = styled.div`
    margin: 1em 0;
    color: #c00;
    font-weight: bold;
`;

interface Props {
    error?: ApolloError | string | undefined,
    children?: ApolloError | string | undefined
}

const _ = (props: Props) => ((props.error || props.children) && <Error>{translate(props.error || props.children)}</Error>) || null;

function translate(error:any) {
    if (typeof error === 'string')
        return error;

    if (error.message)
        return error.message;    
}

export default _;